export const EXPORT_LOCATIONS = 'EXPORT_LOCATTIONS'
export const UPDATE_LOCATION = 'UPDATE_LOCATION'
export const UPDATE_LOCAL_POST = 'UPDATE_LOCAL_POST'
export const CREATE_LOCAL_POST = 'CREATE_LOCAL_POST'
export const UPDATE_FOOD_MENU = 'UPDATE_FOOD_MENU'
export const TRANSFER_LOCATIONS = 'TRANSFER_LOCATIONS'